var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TableListComponent',{ref:"TableListComponent",attrs:{"title":'',"columns":_vm.columns,"rows":_vm.userPropList,"keyField":'propCode',"transCodes":_vm.transCodes,"mode":'edit',"useMaxHeight":false,"useFilter":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }